import { useEffect, useState } from "react";

import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { ErrorModal } from "../components/ErrorModal";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import PowerBi from "../components/PowerBi";
import { useRootContext } from "../contexts/RootContext";
import type { Report } from "../types";
import { environmentReports } from "../utils/constants";

const options: Report[] = environmentReports;

const LandingPage = () => {
  const { idToken, hasTokenError } = useRootContext();
  const [selectedReportId, setSelectedReportId] = useState<string | undefined>();
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(hasTokenError);

  useEffect(() => {
    if (hasTokenError) setIsErrorModalOpen(true);
  }, [hasTokenError]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      {!idToken && !hasTokenError && <LoadingSpinner text="loading credentials..." />}
      {hasTokenError && (
        <ErrorModal
          title="Access Error"
          message="We were unable to verify your credentials to view Power-BI reports. Please try again later"
          onClose={() => setIsErrorModalOpen(false)}
          open={isErrorModalOpen}
        />
      )}
      {idToken && (
        <FormControl sx={{ minWidth: "300px", width: "fit-content" }}>
          <InputLabel id="report-select-label">Report</InputLabel>
          <Select
            labelId="report-select-label"
            id="report-select"
            value={selectedReportId}
            label="Report"
            onChange={(e) => {
              setSelectedReportId(undefined);
              // workaround as changing the reportId does not cause a re-render
              setTimeout(() => setSelectedReportId(e.target.value), 250);
            }}
          >
            {options.map((opt) => (
              <MenuItem value={opt.reportId}>{opt.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {selectedReportId && <PowerBi reportId={selectedReportId} />}
    </Box>
  );
};

export default LandingPage;
